@let stringifyFn = $stringifyFn();

<tui-textfield
  [stringify]="stringifyFn"
  tuiTextfieldSize="m"
  [tuiDropdownMaxHeight]="250"
  [tuiTextfieldCleaner]="$withCleaner()"
>
<input tuiComboBox [ngModel]="value" (ngModelChange)="valueChanged($event)" [strict]="$strict()" placeholder="" [disabled]="isDisabled" [readOnly]="$readOnly()" />

  @let filteredItems = items$ | async | tuiFilterByInput;
  <cdk-virtual-scroll-viewport
   
    [itemSize]="-1"
  >
    <tui-data-list-wrapper
      *tuiDropdown
      [itemContent]="stringifyFn | tuiStringifyContent"
      [items]="filteredItems | tuiFilterByInput"
    ></tui-data-list-wrapper>
  </cdk-virtual-scroll-viewport>
</tui-textfield>
